$(document).on('preloader-finish', () => {
  if ($(document).find('.page').hasClass('blog')) {
    if (innerWidth > 1024) {
      let currentSlideNum = 0;
      let countSlides = $('.blog__slider__textblock__item').length;
      let slideTime = 5;
      let timeOut;

      function nextSlide(slide) {
        currentSlideNum = slide;
        let $currentSlideText = $(document).find('.blog__slider__textblock__item.is-active');
        let $currentSlideImage = $(document).find('.blog__slider__image img.is-active');
        let $nextSlideText = $(document).find(`.blog__slider__textblock__item[data-slide="${slide}"]`);
        let $nextSlideImage = $(document).find(`.blog__slider__image img[data-slide="${slide}"]`);

        $currentSlideText.removeClass('is-active');
        $currentSlideImage.removeClass('is-active');
        $nextSlideText.addClass('is-active');
        $nextSlideImage.addClass('is-active');

        timeOut = setTimeout(() => {
          nextSlide(currentSlideNum < countSlides - 1 ? currentSlideNum + 1 : 0);
        }, slideTime * 1000);
      }

      setTimeout(() => {
        nextSlide(1);
      }, slideTime * 1000)
    } else {
      $('.blog__slider__textblock').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        autoplaySpeed: 5000,
        autoplay: true,
        centerMode: true,
        variableWidth: true,
        slidesToShow: 1,
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
      });

      $('.blog__slider__textblock').on('afterChange', function(event, slick, currentSlide){
        $(document).find('.blog__slider__textblock__item').removeClass('is-active');
        $(document).find(`.blog__slider__textblock__item[data-slide="${currentSlide}"]`).addClass('is-active');
      });

      $(document).on('click', '.blog__slider .slick-slide', (e) => {
        $('.blog__slider__textblock').slick('slickGoTo', $(e.currentTarget).find('.blog__slider__textblock__item').data('slide'));
      })
    }
  }
});